import {CaseStyle} from "kryo";
import {$Sint54} from "kryo/integer";
import {RecordIoType, RecordType} from "kryo/record";

import {$RunIdRef, RunIdRef} from "./run-id-ref.mjs";

export interface BestScoreRun {
  score: number;
  run: RunIdRef;
}

export const $BestScoreRun: RecordIoType<BestScoreRun> = new RecordType<BestScoreRun>({
  properties: {
    score: {type: $Sint54},
    run: {type: $RunIdRef},
  },
  changeCase: CaseStyle.SnakeCase,
});
